import type { IAnswer } from "@/types/types";
import { useState, type FC } from "react";
import AnswerModalContent from "../../answer/AnswerModalContent";
import { Pill } from "@/components/pill/Pill";
import { useDate } from "@/hooks/use-date/useDate";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { Icon } from "@/components/icons/Icon";
import { ModalMobile } from "@/components/modal/mobile/ModalMobile";
import IconButton from "@/components/buttons/IconButton";

interface AnswerMobileProps {
  item: IAnswer;
  empty?: boolean;
  idx: number;
  phaseLabel: string;
}

const AnswerMobile: FC<AnswerMobileProps> = ({
  item,
  empty = false,
  idx,
  phaseLabel,
}) => {
  const translation = useTranslate();
  const [open, setOpen] = useState(false);
  const translate = useTranslate();

  const { formatDate } = useDate();

  const handleOnOpen = () => {
    if (!empty) {
      setOpen(true);
    }
  };

  const handleOnClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div
        role="button"
        onClick={handleOnOpen}
        className="flex group w-full text-left  py-2 px-4 bg-ib-gray-lightest cursor-pointer border-b borde-t border-ib-gray-light-1 hover:bg-ib-gray-light-2"
      >
        <div className="grid grid-rows-[auto_1fr_auto] gap-2 w-full">
          <div className="flex justify-between">
            <div className="flex gap-2 items-center text-ib-gray-dark-2">
              <Icon name="lockClose" className="size-4" />
              <h4 className="font-ib-bold">{translate(phaseLabel)}</h4>
            </div>
            <p className="text-sm text-ib-gray-main">
              {item.updatedAt && formatDate(item.updatedAt?.toString())}
            </p>
          </div>

          <h3
            className="text-md text-ib-gray-darkest truncate w-full"
            title={`${item.status} - ${item.comment}`}
          >
            <span className="font-ib-bold text-gray-900">{item.status}</span>
            {item.comment && (
              <>
                <span className="mx-1"> - </span>
                <span className="font-normal truncate">{item.comment}</span>
              </>
            )}
          </h3>
          <div className="flex space-x-4">
            <Pill
              icon={"images"}
              label={item.images?.length}
              className="bg-ib-gray-borders"
              iconClassName="size-3"
            />
            <Pill
              icon={"comments"}
              label={item.comment ? 1 : 0}
              className="bg-ib-gray-borders"
              iconClassName="size-3"
            />
          </div>
        </div>
      </div>
      {open && (
        <ModalMobile>
          <ModalMobile.Header className="border-b">
            <div className="w-full flex justify-between items-center">
              <div className=" flex-1 flex items-center space-x-4">
                <h3 className="text-lg">{`${translation("action")} ${idx}`}</h3>
                <Pill
                  icon={"lockClose"}
                  label={translation(phaseLabel)}
                  className={"bg-ib-gray-lightest"}
                  iconClassName=""
                />
              </div>
              <IconButton
                icon="close"
                onClick={handleOnClose}
                iconClassName={"size-6"}
                className={"bg-transparent text-ib-red-main"}
              />
            </div>
          </ModalMobile.Header>
          <ModalMobile.Content className="bg-ib-gray-lightest-2">
            <AnswerModalContent item={item} edition={false} />
          </ModalMobile.Content>
        </ModalMobile>
      )}
    </>
  );
};

export default AnswerMobile;
